import { render, staticRenderFns } from "./FeatureText.vue?vue&type=template&id=19b6cf9c&scoped=true&"
import script from "./FeatureText.vue?vue&type=script&lang=js&"
export * from "./FeatureText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b6cf9c",
  null
  
)

export default component.exports